


const DynamicIcon = ({ iconName, alt = "icon", width = 24 }: { iconName: string, alt: string, width: number }) => {
    let iconSrc;
    if (iconName == null) {
        return (<div style={{ width: width, height: width, backgroundColor: "#ccc" }} />);
    }

    try {
        iconSrc = require(`assets/img/th-each-ai/prompt_icons/${iconName}.png`);
    } catch (error) {
        console.error("Icon not found:", error);
        iconSrc = null;
    }

    return iconSrc ? (
        <img src={iconSrc} alt={alt} width={width} />
    ) : (
        <div style={{ width: width, height: width, backgroundColor: "#ccc" }} />
    );
};

export default DynamicIcon;